import axios from 'axios';
import getStickySession from 'utils/getStickySession';
import merge from 'lodash/merge';
import { GetRegion } from '../../constants';
import Utils from '../../utils/Utils';
import { getBrowser } from '../../utils/Platform';
import { getHKS } from '../../utils/HKS';

function Api() {
  const request = axios.create();

  function setConfig(config) {
    // TODO: this shouldn't be here, set config must receive just baseurl and default params
    const baseUrl = config.url_dominio_microfwk;
    const stickySession = getStickySession();
    const params = {
      api_version: config.api_version,
      authpn: config.authpn,
      authpt: config.authpt,
      format: 'json',
      region: GetRegion(),
      device_id: 'web',
      device_category: 'web',
      device_model: 'web',
      device_type: 'web',
      device_so: getBrowser(),
      device_manufacturer: 'generic',
      HKS: getHKS(),
      ...stickySession,
    };
    merge(request.defaults, { baseUrl }, { params });
  }

  return {
    setConfig,
  };
}

const api = new Api();

export default api;
